import { ClientBillConstants as Constants } from '../../types'

const initialState = {
    bills: [],
    total: 0,
    months: []

};

export function billReducer(state = initialState, action) {
    switch (action.type) {  
        
        case Constants.GET:            
            return {
                ...state,
                bills: action?.payload?.bills,
                total: action?.payload?.total,
            };

        case Constants.MONTHS:            
            return {
                ...state,
                months: action?.payload?.months,
            };
            
        case Constants.ADD:
            return {
                ...state,
                bills: [...state?.bills, action?.payload?.bill]
            }

        case Constants.UPDATE:            
            const index = state.bills.findIndex(x => x.id ===  action?.payload?.bill?.id)
            const newArray = [...state.bills];
            if(index > -1)
                newArray[index] = action?.payload?.bill
            return {
                ...state,
                bills: newArray                
            }   

        case Constants.DELETE:
            return{
                ...state,
                bills: state?.bills?.filter(x => parseInt(x?.id) !== parseInt(action?.payload?.id))                
            };
       
        
        case Constants.FAIL:
            return{
                ...state,
                error: action?.error
            }
        
        case Constants.LOADING:
            return{
                ...state,
                error: null
            }

        case Constants.CLEAR:
            return{
                ...state,
                total: 0,
                bills: []
            }
        default:
            return state
    }
}